<div>
  <div class="row add-remove-architect-popup" style="margin-top: 2%">
    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12 mb-4 ">
      <span class="form-inline-new">
        <mat-radio-group [(ngModel)]="architectAction" (change)="architectActionChange($event)">
          <mat-radio-button color="primary" class="radioButton-padding" value="add">Add </mat-radio-button>
          <mat-radio-button color="primary" class="radioButton-padding" value="remove">Remove</mat-radio-button>
        </mat-radio-group>
      </span>
    </div>
    <div class="col-md-3 col-sm-12 col-lg-3 col-xl-3 col-xs-3">
      <label>Role</label>
      <mat-form-field appearance="outline" class="dropdownWidth">
        <mat-select placeholder="Select Role" [(ngModel)]="typeOfArchitect" (selectionChange)="architectTypeChange()">
          @for (role of roleList; track role) {
          <mat-option class="global-mat-option" [value]="role">
            <ng-container>
              {{ role }}
            </ng-container>
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-md-3 col-sm-12 col-lg-3 col-xl-3 col-xs-3">
      <label>User</label>
      <mat-form-field class="inline-form-edit chip-select-stakeholder select-user-dropdown" floatLabel="never">
        <mat-chip-grid #chipList>
          @if (selectedUsers && selectedUsers.givenName) {
          <mat-chip-row class="stk-mat-chip" (removed)="remove()">
            {{ selectedUsers.givenName }} {{ selectedUsers.sn }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip-row>
          }
        </mat-chip-grid>
        <input
          placeholder="Search by MSID/Name"
          [matAutocomplete]="auto"
          (keyup)="keyUpSearch($event)"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        />
        <mat-autocomplete
          showPanel="true"
          class="lob-options-list"
          #auto="matAutocomplete"
          (optionSelected)="selected($event)"
        >
          @for (user of users; track user) {
          <mat-option
            [disabled]="checkexist(user)"
            title="{{ user.MSId }}<{{ user.displayName }}>({{ user.mail }})"
            [value]="user"
          >
            {{ user.MSId || user.msid }}<{{ user.displayName }}>({{ user.mail }})
          </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <div class="col-md-5 col-sm-12 col-lg-5 col-xl-5 col-xs-5">
      <label>LOB / SUBLOB</label>
      @if (cioMappingList) {
      <div>
        <app-multiselect-group-checkbox
          [dropdowndataSource]="cioMappingList"
          [hierarchyDropdownConfig]="hierarchyDropdownConfig"
          [selectValues]="selectValues"
          [disableMultiSelect]="disableMultiSelect"
          (selectedHierarchy)="selectedHierarchy($event)"
          [openAllPanel]="openAllPanel"
          [placeholderText]="'Select Segment/LOB/SubLOB'"
        ></app-multiselect-group-checkbox>
      </div>
      }
    </div>
  </div>
  <div class="row" style="float:right; margin-top: 2%;">
    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12">
      <button
        [disabled]="disableSubmit()"
        (click)="submit()"
        mat-mdc-raised-button
        class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs "
      >
        Submit
      </button>
    </div>
  </div>
  @if (showLoader) {
  <div class="stk-table-loader bulk-loader">
    <app-loader> </app-loader>
  </div>
  }
</div>
